// Boot: The application entry point(s)
// This file is the entry point into the application, and is responsible for calling the app object's init() function
// when everything has loaded. It also tells the global event registry to run the relevant functions
// when the screen resizes and scrolls respectively.

var boot = (function () {

    var loaded = {};
    loaded[RESOURCE_NAME__DOM] = false;
    loaded[RESOURCE_NAME__YOUTUBE] = false;

    return {
        loaded: loaded,
        notifyLoaded: function (resourceName) {
            var scope = this;
            this.loaded[resourceName] = true;
            app.onLoaded({
                resourceName: resourceName,
                currentlyLoaded: scope.getLoaded(),
                allLoaded: scope.allLoaded(),
                getLoaded: scope.getLoaded,
                hasJustLoaded: function (resourceNames) {
                    var isArray = $.isArray(resourceNames);
                    if ((!isArray) || (isArray && resourceNames.length == 1)) {
                        if (isArray) {
                            resourceNames = resourceNames[0];
                        }
                        return resourceNames == resourceName;
                    }
                    var loaded = scope.getLoaded();
                    var loadedResourceNameIsInRequested = resourceNames.indexOf(resourceName) > -1;
                    var filtered = resourceNames.filter(function (reqResourceName) {
                        return loaded.indexOf(reqResourceName) > -1;
                    });
                    var r = (
                        (loadedResourceNameIsInRequested) &&
                        (filtered.length >= resourceNames.length)
                    );
                    return r;
                }
            });
        },
        allLoaded: function () {
            var scope = this;
            var allLoaded = true;
            Object.keys(this.loaded).forEach(function (key) {
                if (!scope.loaded[key]) {
                    allLoaded = false;
                }
            });
            return allLoaded;
        },
        getLoaded: function () {
            var scope = this;
            return Object.keys(this.loaded).filter(function (resourceKey) {
                return scope.loaded[resourceKey];
            });
        }
    };
})();

// On doc ready...
$(function () {
    boot.notifyLoaded(RESOURCE_NAME__DOM);
});

// On youtube ready...
// A function with this 'magic name' must exist for the youtube API
// to call. This is how it lets the rest of the app know it is ready.
function onYouTubeIframeAPIReady() {
    boot.notifyLoaded(RESOURCE_NAME__YOUTUBE);
}
